import {
  billPayNeedsApprovalRouteProps,
  virtualCardsNeedsApprovalRouteProps,
  virtualCardsRequestsRouteProps,
} from 'src/navigation/routeProps'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import VirtualCardsFullPaginatedDataReducer, {
  Actions as VirtualCardsFullPaginatedDataActions,
  initialState as initialVirtualCardsFullPaginatedDataState,
  VirtualCardsFullPaginatedDataState,
} from 'src/redux/virtualCardsFullPaginatedData.reducer'

export interface VirtualCardsRequestsState {
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataState
}

export const initialState: VirtualCardsRequestsState = {
  virtualCardsFullPaginatedData: initialVirtualCardsFullPaginatedDataState,
}

export type Actions = VirtualCardsFullPaginatedDataActions

const CoreVirtualCardsRequestsReducer = (
  state = initialState,
  action: Actions,
): VirtualCardsRequestsState => ({
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataReducer(
    state.virtualCardsFullPaginatedData,
    action as VirtualCardsFullPaginatedDataActions,
  ),
})

const VirtualCardsRequestsReducer = createBackgroundReducer(
  [
    virtualCardsRequestsRouteProps,
    virtualCardsNeedsApprovalRouteProps,
    billPayNeedsApprovalRouteProps,
  ],
  initialState,
  CoreVirtualCardsRequestsReducer,
)

export default VirtualCardsRequestsReducer
